import { Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDateTime } from "~/modules/app/util/formatters";

import { Shared_FormTemplate_QuestionTypeDateTimeFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeDateTimeFragment>;
    value: string | null | undefined;
};

export default function QuestionDateTimeDisplay({ field, value }: Props) {
    const parsedValue = value ? formatDateTime(parseStringToDate(value)) : null;
    return (
        <Stack>
            <Typography variant="caption" color="text.secondary">
                {field.name}
            </Typography>
            <Typography>{parsedValue ?? "—"}</Typography>
        </Stack>
    );
}
